"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERROR_CODES;

(function (ERROR_CODES) {
  ERROR_CODES["MISSING_PARAMETER"] = "MissingParameter";
  ERROR_CODES["INVALID_ARGUMENT"] = "InvalidArgument";
  ERROR_CODES["TABLE_NOT_FOUND"] = "TableNotFound";
  ERROR_CODES["UNSUPPORTED_FIELD_TYPE"] = "UnsupportedFieldType";
  ERROR_CODES["AUTH_FAILED"] = "AuthFailed";
  ERROR_CODES["NOT_IMPLEMENTED"] = "NotImplemented";
  ERROR_CODES["PROPERTY_CONFLICT"] = "PropertyConflict";
})(ERROR_CODES = exports.ERROR_CODES || (exports.ERROR_CODES = {}));